// @flow

import {
  fetchJourneyById,
  fetchJourneyConfirmById,
} from 'redux/v1/journey/actions';
import {isJourneyLoaded} from 'redux/v1/journey/reducer';
import {validateVoucherCodeById} from 'redux/v1/voucher/put/actions';

export function fetchJourney(
  journeyId: number,
  token: string,
  queryParams?: any
): any {
  return async (dispatch, getState) => {
    // @todo replace plain call of params
    await dispatch(fetchJourneyById({journeyId, token, queryParams}));
    const state = getState();
    if (isJourneyLoaded(state)) {
      console.log('Loaded');
    }
  };
}

export function fetchJourneyConfirm(journeyId: number, token: string): any {
  return async (dispatch, getState) => {
    await dispatch(fetchJourneyConfirmById({journeyId, token}));
  };
}

export function validateVoucherCode(
  journeyId: string,
  token: string,
  voucherCode: string
): any {
  return async (dispatch, getState) => {
    // @todo replace plain call of params
    await dispatch(validateVoucherCodeById({journeyId, token, voucherCode}));
  };
}
